export default "__VITE_ASSET__BUIjphNV__"